import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, MenuItem } from '@mui/material'

import { CreateOperationRequestParams } from '../../types.ts'
import { SelectFieldControl, TextFieldControl } from '../../components/form'

import { OFD_PAYMENT_METHODS, OFD_PAYMENT_SUBJECTS } from './constants.ts'

export const OfdFields = (): React.ReactElement | null => {
  const { watch } = useFormContext<CreateOperationRequestParams>()
  const ofgBillMode = watch('ofdBillMode')

  return ofgBillMode === 'AUTO' ? (
    <>
      <Grid item xs={12}>
        <SelectFieldControl<CreateOperationRequestParams> name="ofdPaymentMethodType" fullWidth label="Метод оплаты">
          {OFD_PAYMENT_METHODS.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </SelectFieldControl>
      </Grid>
      <Grid item xs={12}>
        <SelectFieldControl<CreateOperationRequestParams> name="ofdPaymentSubjectType" fullWidth label="Предмет оплаты">
          {OFD_PAYMENT_SUBJECTS.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </SelectFieldControl>
      </Grid>
      <Grid item xs={12}>
        <TextFieldControl<CreateOperationRequestParams>
          fullWidth
          name="ofdName"
          label="Наименование предмета расчета"
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldControl<CreateOperationRequestParams> fullWidth name="ofdNomenclatureCode" label="Товарный код" />
      </Grid>
    </>
  ) : null
}
